import Inventory from 'locales/plus/th/warehouses/inventory.json'
import Adjustment from 'locales/plus/th/warehouses/adjustment.json'
import medicine from 'locales/plus/th/warehouses/medicine.json'
import product from 'locales/plus/th/warehouses/product.json'
import importProduct from 'locales/plus/th/warehouses/import-product.json'

const Warehouses = {
  ...Inventory,
  ...Adjustment,
  ...medicine,
  ...product,
  ...importProduct
}

export default Warehouses
